import { MagicWand01Icon, Send03Icon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';
import { useGenerateQueryForRunsMutation } from '@/hooks/useSwr';
import ProgressCircleIcon from '@/icons/ProgressCircleIcon.svg?react';

export function FilterBarGeneratedInput(props: {
  onSuccess: (query: string, feedbackUrls?: Record<string, string>) => boolean;
  onSubmit?: () => void;
}) {
  const { datasetShareToken } = useParams();
  const [value, setValue] = useState('');

  const mutation = useGenerateQueryForRunsMutation(
    {
      onSuccess: (data) => {
        if (props.onSuccess(data.filter, data.feedback_urls)) {
          setValue('');
        }
      },
    },
    { datasetShareToken }
  );

  return (
    <>
      <form
        className="grid grid-cols-[auto,1fr,auto] items-center overflow-hidden rounded-md border border-secondary"
        onSubmit={(e) => {
          props.onSubmit && props.onSubmit();

          e.stopPropagation();
          e.preventDefault();

          if (value) {
            mutation.trigger({
              json: {
                query: value,
                feedback_keys: [
                  'user_score',
                  'user_edited',
                  'user_removed',
                  'user_opened_run',
                  'user_selected_run',
                  'results_size',
                  'valid_filter',
                ],
              },
            });
          }
        }}
      >
        <div className="-translate-y-[1px] pl-3">
          <MagicWand01Icon className="size-4" />
        </div>
        <input
          placeholder="eg. runs longer than 2s"
          className=" bg-background px-3 py-1 text-sm focus-within:border-brand focus:outline-none"
          size={6}
          name="value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        <button
          type="submit"
          disabled={mutation.isMutating || !value}
          className="p-2 text-ls-black transition-opacity disabled:opacity-70"
        >
          {mutation.isMutating ? (
            <ProgressCircleIcon className="h-5 w-5 animate-spin" />
          ) : (
            <Send03Icon className="h-5 w-5" />
          )}
        </button>
      </form>
      <ExpandableErrorAlert error={mutation.error} />
    </>
  );
}
